import { useNavigate } from "react-router-dom";
import "../PageCommon.css";
import "./About.css";
import { useEffect } from "react";

const AboutPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
      if (!localStorage.getItem('token')) {
        navigate('/signin');
      }
  }, [navigate]);
  
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="Page__label">
          <h2>About</h2>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;